import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Checkbox from 'antd/lib/checkbox';

const Locked = ({ t, value, onChange }) => (
  <Checkbox checked={value} onChange={onChange}>
    {t('Deaktivovaný')}
  </Checkbox>
);

Locked.propTypes = {
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default translate()(Locked);



// WEBPACK FOOTER //
// ./src/features/account-management/components/filters/Locked.js